<div class="w-full p-5">
    <div class="max-w-[530px] w-full mx-auto">
        <h3 class="text-4xl font-semibold text-center">Verify OTP</h3>
        <span class="block text-base text-center mt-2.5">
            Enter the 6-digit code sent to <span class="font-bold text-dark">{{ userEmail }}</span>
            <button type="button" (click)="changeEmail()" class="inline-block text-xs font-bold text-primary underline ml-2 cursor-pointer border-none bg-transparent outline-none">
                Wrong Email?
            </button>
        </span>
        <div class="w-full space-y-6 mt-8">
            <div class="flex justify-center">
                <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 6, allowNumbersOnly: true }"></ng-otp-input>
            </div>
            <div class="flex items-center justify-between text-sm select-none">
                <span class="text-slate-500 font-medium">
                    Didn't receive the code?
                </span>
                <button type="button" 
                        (click)="resendOTP()" 
                        [disabled]="resendTimer > 0 || isResending"
                        class="text-sm font-bold border-none bg-transparent outline-none transition-colors"
                        [ngClass]="(resendTimer > 0 || isResending) ? 'text-slate-400 cursor-not-allowed' : 'text-primary hover:underline cursor-pointer'">
                    <span *ngIf="resendTimer > 0">Resend OTP in 00:{{ resendTimer < 10 ? '0' + resendTimer : resendTimer }}</span>
                    <span *ngIf="resendTimer === 0 && !isResending">Resend OTP</span>
                    <span *ngIf="isResending">Resending...</span>
                </button>
            </div>
            <button type="button" 
                    (click)="submitOTP()" 
                    [disabled]="otpCode.length !== 6 || isBtnLoading"
                    class="w-full flex items-center justify-center text-base font-bold border border-primary bg-primary hover:bg-white text-white hover:text-primary outline-none rounded-lg anim p-4 cursor-pointer disabled:bg-slate-300 disabled:border-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed transition-all">
                <span class="inline-block" *ngIf="isBtnLoading">
                    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-inherit" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"> 
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle> 
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path> 
                    </svg>
                </span>
                <span>{{ isBtnLoading ? 'Verifying...' : 'Verify & Continue' }}</span>
            </button>
            <p class="text-sm font-bold text-center">Need to log in? <span class="inline-block text-primary underline cursor-pointer" [routerLink]="'/login'">Log In</span></p>
        </div>
    </div>
</div>